import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { MentionElement, MentionElementGroup } from '@recruitee/prosemirror';
import { MentionsStream$ } from '@recruitee/prosemirror/angular';

@Injectable()
export class FilteredMentions$
  extends BehaviorSubject<MentionElement[] | MentionElementGroup[]>
  implements MentionsStream$, OnDestroy
{
  constructor() {
    super([]);
  }
  public ngOnDestroy() {
    this.complete();
  }
}
